import { DataBean } from "../DataBean";

export class Provision extends DataBean {

    public async exportProvisionsSpreadSheet(date: any, idemployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProvisionsSpreadSheet_java.util.Date_Number", [date, idemployee]);
    }

}